import React, { Component } from "react";
import { connect } from "react-redux";
import { CreditCard } from "react-bootstrap-icons";
import messages from "./Subscription.messages";
import { Image, Panel, Button, Row, Col } from "react-bootstrap";
import moment from "moment";
import Promise from "bluebird";

import * as actions from "../../../redux/user/actions";

import { getActiveProject } from "../../../redux/projects";
import {
  isCreatingCustomer,
  isCreatingSubscription,
  showIncorrectCouponError,
  showCouponSuccess,
} from "../../../redux/user";
import plans from "../../../data/plans.json";
import { findPlanName, signedUpMoreThan7DaysAgo } from "../../../helpers/Utils";

import type User from "../../models/User";
import type Project from "../../models/Project";
import type Plan from "../../models/Plan";
import { Link } from "react-router-dom";

import PlanView from "./plan/Plan";
import CardModal from "../components/modals/card-modal/CardModal";
import GradientButton from "../../../components/input/GradientButton";

type Props = {
  user: User,
  plans: PlanCollection,
};

type StateProps = {};

type State = {
  planId: string,
  showCardModal: boolean,
  selectedPlanId: string,
};

class Subscription extends Component {
  props: Props;
  state: State = {
    planId: this.props.user.planId,
    showCardModal: false,
    selectedPlanId: null,
  };
  createCustomerPromise: ?Promise<void>;
  updateCustomerPromise: ?Promise<void>;
  addPaymentSourcePromise: ?Promise<void>;
  createCustomerSubscriptionPromise: ?Promise<void>;
  updateCustomerSubscriptionPromise: ?Promise<void>;
  cancelSubscriptionPromise: ?Promise<void>;
  fetchCouponPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  subscribeUser = (planId: string) => {
    if (!this.props.user) {
      return;
    }
    if (planId == this.props.user.planId) {
    } else {
      if (this.props.user.subscriptionId) {
        this.handleUpdateSubscription(planId);
      } else if (this.props.user.customerId) {
        this.handleSubscribeUser(planId);
      } else {
        this.setState({
          selectedPlanId: planId,
        });
        this.openCardModal();
      }
    }
  };

  checkIfPlanIsSelected(token: string, coupon: string) {
    if (this.state.selectedPlanId != null) {
      this.validateCouponAndCreateCustomer(token, coupon);
    } else {
      this.createCustomer(token);
    }
  }

  async validateCoupon(coupon: string) {
    await this.props.fetchCoupon({ coupon: coupon });
  }

  async validateCouponAndCreateCustomer(token: string, coupon: string) {
    await this.props.fetchCoupon({ coupon: coupon });
    this.handleCreateCustomer(token, coupon);
  }

  async handleCreateCustomer(token: string, coupon: string) {
    await this.props.createCustomer({ token: token });
    this.closeCardModal();
    if (this.props.showCouponSuccess) {
      this.handleSubscribeUserWithCoupon(this.state.selectedPlanId, coupon);
    } else {
      this.handleSubscribeUser(this.state.selectedPlanId);
    }
  }

  createCustomer(token: string) {
    this.createCustomerPromise = Promise.resolve(
      this.props.createCustomer({ token: token })
    );
    this.closeCardModal();
  }

  updateCustomer(token: string) {
    this.updateCustomerPromise = Promise.resolve(
      this.props.updateCustomer({
        token: token,
        customerId: this.props.user.customerId,
      })
    );
    this.closeCardModal();
  }

  handleSubscribeUser(planId: string) {
    if (!this.props.user.customerId) {
      return;
    }
    this.createCustomerSubscriptionPromise = Promise.resolve(
      this.props.createCustomerSubscription({
        customerId: this.props.user.customerId,
        planId: planId,
        coupon: null,
        // coupon: "tFRpVxHt", //DEBUG
      })
    );
  }

  handleSubscribeUserWithCoupon(planId: string, coupon: string) {
    if (!this.props.user.customerId) {
      return;
    }
    this.createCustomerSubscriptionPromise = Promise.resolve(
      this.props.createCustomerSubscription({
        customerId: this.props.user.customerId,
        planId: planId,
        coupon: coupon,
      })
    );
  }

  handleUpdateSubscription(planId: string) {
    if (!this.props.user.subscriptionId) {
      return;
    }
    this.updateCustomerSubscriptionPromise = Promise.resolve(
      this.props.updateCustomerSubscription({
        subscriptionId: this.props.user.subscriptionId,
        planId: planId,
      })
    );
  }

  openCardModal = () => {
    this.setState({
      showCardModal: true,
    });
  };

  closeCardModal = () => {
    this.setState({
      showCardModal: false,
    });
  };

  render() {
    return (
      <div className="subscription-content">
        <div className="subscription-title-container">
          <h1 className="project-title">Subscription</h1>
          {this.renderCardButton()}
        </div>
        {this.renderPlans()}
        {this.state.showCardModal ? this.renderCardModal() : null}
      </div>
    );
  }

  renderCardButton() {
    if (this.props.user.customerId) {
      return (
        <GradientButton
          gradient="1/1"
          handleClick={this.openCardModal}
          icon={<CreditCard size="14" />}
          title="Update Card"
        />
      );
    }
  }

  renderPlans() {
    const currentPlanName = findPlanName(this.props.user);
    const singleExpired = false; //TODO single has been disabled for now
    const trialExpired = signedUpMoreThan7DaysAgo();

    return (
      <div>
        <Row>
          {plans
            .filter((plan) => !plan.disabled)
            .map(this.renderPlan(currentPlanName, singleExpired, trialExpired))}
        </Row>
      </div>
    );
  }

  renderPlan =
    (currentPlanName, singleExpired, trialExpired) =>
    (plan: Plan, index: number) => {
      return (
        <PlanView
          key={plan.planId}
          plan={plan}
          onRequestSubscribePlan={() => this.subscribeUser(plan.planId)}
          currentPlanId={this.props.user.planId}
          currentPlanName={currentPlanName}
          singleExpired={singleExpired}
          trialExpired={trialExpired}
        />
      );
    };

  renderCardModal = () => {
    if (this.props.user.customerId) {
      return (
        <CardModal
          onModalClose={() => this.closeCardModal()}
          user={this.props.user}
          isNewCustomer={false}
          updateCustomer={(token) => this.updateCustomer(token)}
        />
      );
    } else {
      return (
        <CardModal
          onModalClose={() => this.closeCardModal()}
          user={this.props.user}
          isNewCustomer={true}
          createCustomer={(token, coupon) =>
            this.checkIfPlanIsSelected(token, coupon)
          }
          selectedPlanId={this.state.selectedPlanId}
          showIncorrectCouponError={this.props.showIncorrectCouponError}
          validateCoupon={(coupon) => this.validateCoupon(coupon)}
          showCouponSuccess={this.props.showCouponSuccess}
        />
      );
    }
  };
}

const mapStateToProps = (state) => {
  return {
    isCreatingCustomer: isCreatingCustomer(state),
    isCreatingSubscription: isCreatingSubscription(state),
    showIncorrectCouponError: showIncorrectCouponError(state),
    showCouponSuccess: showCouponSuccess(state),
  };
};

export default connect(mapStateToProps, actions)(Subscription);



// WEBPACK FOOTER //
// ./src/views/user/subscription/Subscription.js